import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "text-component" }
const _hoisted_2 = { class: "component-contents" }
const _hoisted_3 = { class: "text-container" }
const _hoisted_4 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_5 = {
  key: 1,
  class: "help is-danger"
}
const _hoisted_6 = {
  key: 0,
  class: "invalid-warning"
}

import { StateViewModel } from '@/features/bots/models/designer';
import TextEditor from '@/features/bots/components/designer/TextEditor/TextEditor.vue';
import IslandBadge from './IslandBadge.vue';
import { required } from '@vuelidate/validators';
import ErrorIcon from 'vue-material-design-icons/AlertCircleOutline.vue';
import { computed, PropType, ref, watch } from 'vue';
import useVuelidate from '@vuelidate/core';
import VuelidateUtil from '@shared/util/vuelidateUtil';


export default /*@__PURE__*/_defineComponent({
  __name: 'TextComponent',
  props: {
  value: {
    type: Object as PropType<StateViewModel>,
    required: true,
  },
},
  emits: ["state-updated"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

__expose({
  focusOnInput,
});

const state = ref<StateViewModel>({
  id: '',
  component: 'Text',
});
const invalidAttribute = ref(false);
const textEditor = ref<typeof TextEditor | null>(null);

const validations = {
  state: {
    text: {
      required,
      attributeInvalid: (value: string) => !invalidAttribute.value,
    },
  },
};

const $v = useVuelidate(validations, { state });
const isTextRequiredInvalid = computed(() => VuelidateUtil.isRequiredInvalid($v, (v) => v.state.text));
const isTextAttributeInvalid = computed(() =>
  VuelidateUtil.isValidationInvalid($v, (v) => v.state.text, 'attributeInvalid'),
);

watch(
  () => props.value,
  (value: StateViewModel) => (state.value = value),
  { immediate: true },
);

async function textUpdated(text: string) {
  if (state.value.text === text) {
    return;
  }
  state.value.text = text;

  $v.value.$touch();
  state.value.invalid = $v.value.$invalid;

  emit('state-updated', state.value);
}

function setInvalidAttribute(val: boolean) {
  invalidAttribute.value = val;
  $v.value.$touch();
  state.value.invalid = $v.value.$invalid;
}

function focusOnInput() {
  textEditor.value?.focusElement();
  textEditor.value?.startEditing();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(IslandBadge, { type: "text" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(TextEditor, {
          ref_key: "textEditor",
          ref: textEditor,
          value: state.value.text,
          placeholder: 'Enter a message...',
          onTextUpdated: textUpdated,
          onError: setInvalidAttribute
        }, null, 8, ["value"]),
        (isTextRequiredInvalid.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Message text must not be empty"))
          : _createCommentVNode("", true),
        (isTextAttributeInvalid.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Message contains an invalid attribute"))
          : _createCommentVNode("", true)
      ])
    ]),
    (state.value.invalid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(ErrorIcon, { class: "icon-1-3x" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})